export default "/kiban/_next/static/images/reinForcementCnt-320dbb6696b325b860fb0c11ee7e4a8c.png";